import { TProductRefId } from "@/types/plan";

export function buildAddPayload(
  cartItems: { id: string; quantity?: number }[],
) {
  return cartItems.map((item) => ({
    product_id: item.id,
    action: "add" as const,
    quantity: item.quantity || 1,
  }));
}

export function buildRemovePayload(productIds: TProductRefId[]) {
  return productIds.map((productId) => ({
    product_id: productId,
    action: "remove" as const,
    quantity: 1,
  }));
}

export function extractConfirmedCodes(
  response:
    | { discounts?: { invalid?: boolean; coupon_code: string }[] }
    | null
    | undefined,
): string[] {
  return (
    response?.discounts?.filter((d) => !d.invalid).map((d) => d.coupon_code) ??
    []
  );
}
